<template>
    <div class="solutionguide__step-wrapper" v-if="isActiveStep(step)">
        <p class="lead"><strong>{{$t('result.headline', { segment: $store.state.segment.name, application: $store.state.application.name, component: $store.state.component.name })}}</strong></p>
        <result-table :rows="mainTableRows" />
        <div v-if="additionalTableRows.length > 0">
            <div class="solutionguide__result-tblfooter solutionguide__result-tblfooter--top">
                <div class="button-wrapper right spacer--top-none">
                    <GlobalButton v-if="$store.state.ctalink && $store.state.ctalink.url" theme="brand" icon="calendar" :href="$store.state.ctalink.url" :target="$store.state.ctalink.target">{{ $t('result.button.cta') }}</GlobalButton>
                </div>
            </div>
            <template v-if="isMobile">
                <global-accordion accordionType="3" theme="theme--grey" :open="isAccordionOpen" @toggleAccordion="toggleAccordion">
                    <template slot="header">
                        {{$t('result.headline2', { segment: $store.state.segment.name, application: $store.state.application.name, component: $store.state.component.name })}}
                    </template>
                    <template slot="body">
                        <result-table :rows="additionalTableRows" />
                    </template>
                </global-accordion>
            </template>
            <template v-else>
                <p class="lead"><strong>{{$t('result.headline2', { segment: $store.state.segment.name, application: $store.state.application.name, component: $store.state.component.name })}}</strong></p>
                <result-table :rows="additionalTableRows" />
            </template>
        </div>
        <div class="solutionguide__result-tblfooter solutionguide__result-tblfooter--bottom">
            <div class="solutionguide__result-line"></div>
            <div class="button-wrapper full-width--xs">
                <a class="solutionguide__restart" href="#" @click="restart">{{ $t('result.button.restart') }}</a>
                <GlobalButton v-if="$store.state.ctalink && $store.state.ctalink.url" theme="brand" icon="calendar" :href="$store.state.ctalink.url" :target="$store.state.ctalink.target">{{ $t('result.button.cta') }}</GlobalButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import Vue from "vue";
    import {mapGetters, mapState} from "vuex";
    import {STEP} from "../store/solutionGuideStore"
    import StepWrapper from "./step-wrapper.vue";
    import GlobalButton from "../../../../../global/global-elements/global-button/global-button.vue";
    import ResultTable, {ResultTableRow} from "./result-table.vue";
    import GlobalAccordion from "../../../../../global/global-elements/global-accordion/global-accordion.vue";

	export default Vue.extend({
        name: "step-result",
        components: {GlobalAccordion, ResultTable, GlobalButton, StepWrapper},
        data() {
            return {
                step: STEP.Result,
                isAccordionOpen: false
            }
        },
        computed: {
            ...mapGetters(['isMobile', 'isActiveStep', 'getProperty', 'getProduct']),
            mainTableRows(): ResultTableRow[] {
                return [{
                    component: this.$store.state.component,
                    product: this.$store.state.result,
                    // propertyIds: this.$store.state.result.propertyIds //[...this.$store.state.component.commonPropertyIds, ...this.$store.state.properties] // Bullshit...sollte einfach alles vom Produkt anzeigen
                }]
            },
            additionalTableRows(): ResultTableRow[] {
                const rows: ResultTableRow[] = []

                for (const component of this.$store.state.application.components) {
                    if (component === this.$store.state.component) {
                        continue;
                    }

                    const row: ResultTableRow = {
                        component: component,
                        product: this.getProduct(component.productIds[0])
                    }

                    rows.push(row)
                }

                return rows;
            }
        },
        methods: {
            toggleAccordion() {
                this.isAccordionOpen = !this.isAccordionOpen;
            },
            restart(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
                event.preventDefault()
                event.stopPropagation()
                this.$store.dispatch('restart')
                return false
            }
        }
    })
</script>
